import type { IFilterCondition, IListViewState } from '@platform/core/types';

/** Збирає рядок фільтр-DSL (05-API/filter-dsl.md) з умов та стану пункту меню. */
export function buildFilter(parts: Array<string | IFilterCondition | null | undefined>): string {
  return parts
    .filter((p): p is string | IFilterCondition => Boolean(p))
    .map((p) => (typeof p === 'string' ? p : conditionToDsl(p)))
    .filter((s) => s.length > 0)
    .join(';');
}

export function conditionToDsl(c: IFilterCondition): string {
  const values = c.values.map((v) => encodeURIComponent(v)).join(',');
  return c.values.length ? `${c.field}:${c.op}:${values}` : `${c.field}:${c.op}`;
}

/** Фільтр зі стану списку: вкладка етапу (поле подання «Етапи», типово status), теги, колонкові фільтри. */
export function filterFromState(state: Pick<IListViewState, 'columnFilter' | 'tagFilter' | 'stage'>, stageField = 'status'): string {
  return buildFilter([
    state.columnFilter,
    state.stage ? { field: stageField, op: 'eq', values: [state.stage] } : null,
    state.tagFilter.length ? { field: 'tags', op: 'has', values: state.tagFilter } : null,
  ]);
}

export function presetFromQuickFilter(quick: IListViewState['quickFilter']): 'mine' | 'open' | 'overdue' | undefined {
  return quick === 'all' ? undefined : quick;
}
